export enum SelectVariant {
    Standard = 'standard',
    Outlined = 'outlined',
    Filled = 'filled',
}
